import { useNavigate } from '@tanstack/react-router';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useLaboratoryEdit } from '@/module/Laboratory/model/LaboratoryQuery';
import {
  LaboratorySchema,
  defaultLaboratoryValues,
  laboratorySchema,
} from '@/module/Laboratory/model/LaboratorySchema';

import { useAppNotification } from '@feature/utils';

import { LaboratoryForm } from './LaboratoryForm';
import { Laboratory } from './model/LaboratoryTypes';

interface LaboratoryEditProps {
  laboratory: Laboratory;
  researchCenterId: string;
}

const convert = (laboratory: Laboratory): LaboratorySchema => ({
  ...laboratory,
});

export function LaboratoryEdit(props: LaboratoryEditProps) {
  const { laboratory, researchCenterId } = props;
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useLaboratoryEdit(laboratory.id);

  const notification = useAppNotification();
  const onSubmit = (values: LaboratorySchema) => {
    mutate(
      { ...values, researchCenter: { id: Number(researchCenterId) } },
      {
        onError: notification.error,
        onSuccess: notification.success,
      },
    );
  };

  const values = useMemo(() => convert(laboratory), [laboratory]);
  const navigate = useNavigate();

  return (
    <LaboratoryForm
      title={t('laboratories.form.title.edit')}
      schema={laboratorySchema}
      defaultValues={defaultLaboratoryValues}
      isError={isError}
      isSuccess={isSuccess}
      values={values}
      onSubmit={onSubmit}
      isSubmitting={isPending}
      onCancel={() => navigate({ to: '..' })}
    />
  );
}
